import React from 'react';
import './FeatureOverview.css';
import girl1 from '../../static/svg/features/girl_1.svg';
import girl3 from '../../static/svg/features/girl_3.svg';
import boy2 from '../../static/svg/features/boy_2.svg';
import pencil from '../../static/svg/features/pencil.svg';
import writing from '../../static/svg/features/writing.svg';

const FeatureOverview = () => {
  return (
    <section className="feature-overview">
      <div className="feature-container">
        <div className="feature-background">
          {/* Background decorative elements */}
          <div className="background-decorations">
            {/* Colored star decorations */}
            <div className="star-decoration star-pos-1 star-fuchsia">
              <div className="star-inner"></div>
            </div>
            <div className="star-decoration star-pos-2 star-orange">
              <div className="star-inner"></div>
            </div>
            <div className="star-decoration star-pos-3 star-blue">
              <div className="star-inner"></div>
            </div>
            <div className="star-decoration star-pos-4 star-green">
              <div className="star-inner"></div>
            </div>
            <div className="star-decoration star-pos-5 star-fuchsia">
              <div className="star-inner"></div>
            </div>
            <div className="star-decoration star-pos-6 star-orange">
              <div className="star-inner"></div>
            </div>
            <div className="star-decoration star-pos-7 star-blue">
              <div className="star-inner"></div>
            </div>
            <div className="star-decoration star-pos-8 star-green">
              <div className="star-inner"></div>
            </div>
            <div className="star-decoration star-pos-9 star-fuchsia">
              <div className="star-inner"></div>
            </div>
            <div className="star-decoration star-pos-10 star-orange">
              <div className="star-inner"></div>
            </div>
            <div className="star-decoration star-pos-11 star-blue">
              <div className="star-inner"></div>
            </div>
            <div className="star-decoration star-pos-12 star-green">
              <div className="star-inner"></div>
            </div>
          </div>

          <div className="feature-content-wrapper">
            {/* Title Section */}
            <div className="feature-title-section">
              <div className="feature-subtitle">Features</div>
              <div className="feature-title">Why You'll Love Child Story Time</div>
            </div>
            
            {/* Feature Cards */}
            <div className="feature-cards">
              {/* Feature 1 - Fully Personalized Stories */}
              <div className="feature-card orange">
                <div className="feature-text-container">
                  <h2 className="feature-card-title">Fully Personalized Stories</h2>
                  <p className="feature-card-description">
                    At Child Story Time, every book is a one-of-a-kind creation. You're not just inserting a name you're shaping an entire world built around your child's imagination. From choosing the hero's name and personality traits to selecting favorite colors, hobbies, and even magical companions, each story feels like it was crafted just for them.
                  </p>
                </div>
                
                {/* Characters */}
                <div className="girl1-container">
                  <img src={girl1} alt="Girl reading" className="girl1-illustration" />
                </div>
              </div>
              
              {/* Feature 2 - Easy-to-Use AI Story Creator */}
              <div className="feature-card fuchsia">
                <div className="feature-text-container">
                  <h2 className="feature-card-title">Easy-to-Use AI Story Creator</h2>
                  <p className="feature-card-description">
                    Creating a fully personalized storybook sounds complicated but with Child Story Time, it's incredibly simple. Our AI guides you step-by-step, making it easy for anyone (even if you're not "techy") to create a rich, imaginative book in just a few minutes. You choose a theme, answer a few fun prompts, and watch the magic happen.
                  </p>
                </div>
                
                {/* Character and Pencil */}
                <div className="boy2-container">
                  <img src={boy2} alt="Boy with book" className="boy2-illustration" />
                </div>
                <div className="pencil-container">
                  <img src={pencil} alt="Pencil" className="pencil-illustration" />
                </div>
                <div className="writing-container">
                  <img src={writing} alt="Writing" className="writing-illustration" />
                </div>
              </div>
              
              {/* Feature 3 - Download, Share, and Print */}
              <div className="feature-card blue">
                <div className="feature-text-container">
                  <h2 className="feature-card-title">Download, Share, and Print Your Storybook</h2>
                  <p className="feature-card-description">
                    Once your masterpiece is ready, the magic doesn't have to stay on the screen. You can download a digital copy of your storybook to read anytime, anywhere or even share it with family members and friends. Want a keepsake? We offer high-quality printed versions too.
                  </p>
                </div>
                
                {/* Girl illustration */}
                <div className="girl3-container">
                  <img src={girl3} alt="Girl with book" className="girl3-illustration" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeatureOverview;